import { regex } from "../utils/regex";

function justNumber(text?: string) {
    return text?.replace(regex.notDigitRegex, '') ?? '';
}

function getShortFollowers(num: number) {
    function intlFormat(num: number) {
        return new Intl.NumberFormat().format(Math.floor(num * 10) / 10);
    }

    if (num >= 1000000)
        return intlFormat(num / 1000000) + 'M';
    if (num >= 1000)
        return intlFormat(num / 1000) + 'k';
    return intlFormat(num);
}

function read(num: number) {
    return num?.toFixed(2)??0;
}


function moneyFormat(value: number) {
    if(!value)
        value = 0;

    let number = value?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 });
    
    if(!number.includes("R$")){
        number = "R$ "+number;
    }

    return number;
}
function getRandomNumber1And16(): number {
  return Math.floor(Math.random() * 2) + 1;
}
function getRandomNumber16And20(): number {
  return Math.floor(Math.random() * 20) + 15;
}


const HelperNumber = {
    justNumber,
    getShortFollowers,
    read,
    moneyFormat,
    getRandomNumber1And16,
    getRandomNumber16And20
}

export default HelperNumber;